import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=4758a79c&scoped=true&"
import script from "./Cargo.vue?vue&type=script&lang=js&"
export * from "./Cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758a79c",
  null
  
)

export default component.exports